<style lang="scss">
.zoezi-workout-details{
    margin: 16px 0;
}
.zoezi-workout-details>.zoezi-workout-categories{
    display:flex;
    gap: 0;
    flex-wrap: wrap;
}
.zoezi-workout-details>.zoezi-workout-categories>div{
    padding: 8px 16px;
    cursor:pointer;
    margin-bottom: 10px;
    position:relative;
    transition:color 250ms ease-in-out;
}
.zoezi-workout-details>.zoezi-workout-categories>div.active{
    color:var(--z-primary);
}
.zoezi-workout-details>.zoezi-workout-categories>div:after{
    content: '';
    position:absolute; left:50%; right:50%; bottom:0;
    border-bottom:solid 2px transparent;
    transition:all 250ms ease-in-out;
}
.zoezi-workout-details>.zoezi-workout-categories>div.active:after{
    border-bottom:solid 2px var(--z-primary);
    left:0; right:0;
}
.zoezi-workout-details>.zoezi-workout-items{
    display:flex;
    flex-wrap:wrap;
    gap:16px;
}
.zoezi-workout-details>.zoezi-workout-items>article{
    width:100%;
    position:relative;
}
.zoezi-workout-details>.zoezi-workout-items>article>.v-image{
    width:100%;
}
.zoezi-workout-details>.zoezi-workout-items span.z-wo-color{
    display:none;
}
.zoezi-workout-details>.zoezi-workout-items.zoezi-coloured span.z-wo-color{
    display:block;
    position:absolute;
    left:0; top:0; width:100%; height:100%;
    background: currentcolor;
    z-index:-1;
    transition:all 250ms ease-in-out;
}
.zoezi-workout-details>.zoezi-workout-items.zoezi-coloured>article>.v-image span.z-wo-color{
    top:50%;
    height:50%;
}
.zoezi-workout-details>.zoezi-workout-items.zoezi-coloured>article:hover>.v-image span.z-wo-color{
    top: 100%;
    height:0;
}
.zoezi-workout-details>.zoezi-workout-items.zoezi-coloured>article>span.z-wo-color{
    opacity:1;
    pointer-events:none;
    z-index: -1;
}
.zoezi-workout-details>.zoezi-workout-items>article>h3{
    color:var(--z-primary);
    padding: 8px 4px 8px 8px;
    position:relative;
    z-index:1;
}
.zoezi-workout-details>.zoezi-workout-items>article>.zoezi-workout-link{
    display:inline-block;
    cursor:pointer;
    color: var(--z-primary);
    padding:4px 8px;
}
.zoezi-workout-details>.zoezi-workout-items.zoezi-coloured>article.text-white>h3{
    color:white;
    text-shadow: 0 1px 3px rgba(0,0,0,.3);
}
.zoezi-workout-details>.zoezi-workout-items.zoezi-coloured>article.text-black>h3{
    color:rgba(0,0,0,.8);
    text-shadow: 0 1px 1px rgba(255,255,255,.3);
}
.zoezi-workout-details>.zoezi-workout-items>article>h3+div{
    padding: 4px 8px;
}
.zoezi-workout-details>.zoezi-workout-items.zoezi-coloured>article>h3+div{
    padding-top:16px;
}
.zoezi-sm>.zoezi-workout-details>.zoezi-workout-items>article{
    width:calc(50% - 8px);
}
.zoezi-md>.zoezi-workout-details>.zoezi-workout-items>article{
    width:calc(33% - 8px);
}
.zoezi-lg>.zoezi-workout-details>.zoezi-workout-items>article{
    width:calc(25% - 8px);
}
.zoezi-xl>.zoezi-workout-details>.zoezi-workout-items>article{
    width:calc(20% - 8px);
}
.zoezi-workout-details.z-style-card>.zoezi-workout-items>article{
    background:white;
    border:solid 1px rgba(0,0,0,.2);
    overflow:hidden;
    border-radius:5px;
    box-shadow: 0 1px 3px #00000024,
        0 3px 9px #00000010,
        0 9px 27px #00000010;
}
.zoezi-workout-details.z-style-card>.zoezi-workout-items>article>div,
.zoezi-workout-details.z-style-card>.zoezi-workout-items>article>h3{
    padding-left: 16px; padding-right:16px;
}
.zoezi-workout-details.z-style-card>.zoezi-workout-items>article>.zoezi-workout-link{
    padding: 4px 16px 8px;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-categories{
    margin-bottom:16px;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-categories>div:after{
    width: 0; height:0; bottom:50%;
    left: calc(50%);
    border:none;
    border-radius:100px;
    background:transparent;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-categories>div.active:after{
    bottom:-5px;
    width: 10px; height:10px;
    left: calc(50% - 5px);
    background:var(--z-primary);
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-categories>div:first-child{
    margin-left:auto;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-categories>div:last-child{
    margin-right:auto;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article{
    margin-left:auto; margin-right:auto;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article .v-image{
    width: 33%;
    transition:all 500ms ease-in-out;
    margin:0 auto;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article:nth-child(5n-3) .v-image{border-radius:31% 69% 70% 30% / 30% 44% 56% 70%;}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article:nth-child(5n-2) .v-image{border-radius:41% 59% 33% 67% / 52% 66% 34% 48%;}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article:nth-child(5n-1) .v-image{border-radius:58% 42% 48% 52% / 52% 56% 44% 48%}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article:nth-child(5n+0) .v-image{border-radius:80% 20% 35% 65% / 55% 21% 79% 45%}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article:nth-child(5n+1) .v-image{border-radius:43% 57% 50% 50% / 66% 36% 64% 34%}

.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article .v-image .v-responsive__content>span.z-wo-color{
    height:100%;
    top:0;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article .v-image>.v-responsive__sizer{
    padding-bottom: 100% !important
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article .zoezi-workout-link{
    display:block;
    text-align:center;
    margin-top:-8px;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article h3,
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article h3+div{
    text-align:center;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items:not(.zoezi-coloured)>article h3{
    background:rgba(255,255,255,.7);
    backdrop-filter:blur(5px);
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items.zoezi-coloured>article h3{
    display:inline-block;
    left:50%;
    margin-top:-48px;
    padding:4px 16px;
    transform:translateX(-50%);
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items.zoezi-coloured>article h3>span.z-wo-color{
    border-radius:50px;
}
.zoezi-workout-details.z-style-soft>.zoezi-workout-items>article:hover .v-image{
    width:40%;
    border-radius:50%;
    margin-bottom: -7%;
}
</style>

<template>
    <div class="zoezi-workout-details" :class="[styleClass]">
        <div class="zoezi-workout-categories" v-if="workoutCategories.length>1 && filterable">
            <div @click="toggleFilter(null)" :class="{active : categoryFilter == null}">{{$translate('All')}}</div>
            <div v-for="category in workoutCategories" :key="category.id" @click="toggleFilter(category.id)" :class="{active : categoryFilter == category.id}">
                {{category.name}}
            </div>
        </div>
        <div class="zoezi-workout-items" :class="{'zoezi-coloured' : !coloured}">
            <article v-for="workout in filteredWorkoutTypes" :key="workout.id" :class="[getTextColor(workout.color)]">
                <v-auto-img v-if="!$root.edit || workout.imagekey" ref="img" :ar="3/2" :src="workout.imagekey">
                    <span class="z-wo-color" :style="getShade(workout.color)"></span>
                </v-auto-img>
                <h3>{{workout.name}}<span class="z-wo-color" :style="{color: workout.color}"></span></h3>
                <div v-html="stripHtml(workout.description)"></div>
                <a class="zoezi-workout-link z-no-underline" v-if="link" :href="getLink(workout.id)" @click.prevent="showType(workout.id)">{{$translate('Show')}} {{workout.name}}-{{$translate('workouts')}}</a>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-workout-types',
    zoezi: {
        title: 'Workout descriptions',
        icon: 'mdi-book-information-variant'
    },
    props: {
        categories: {
            title: 'Kategorier',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                placeholder: 'Show all categories',
                getItems: () => window.$booking.getWorkoutCategories()
            },
            default: () => []
        },
        listStyle: {
            title: 'Appearance',
            type: Number,
            fulltype: 'select',
            typeinfo: {
                text: 'name',
                value: 'id',
                clearable: false,
                placeholder: 'Standard',
                getItems: () => ([
                    {id: 0, name: 'Standard'},
                    {id: 1, name: 'Cards'},
                    {id: 2, name: 'Soft'},
                ].map(x => ({...x, name: window.$translate(x.name)})))
            },
            default: 0
        },
        link: {
            title: 'Page with group exercise schedule',
            type: String,
            fulltype: 'page'
        },
        linkParam: {
            title: 'Parameter to page with group training schedule',
            type: String,
            default: 'workoutType'
        },
        filterable: {
            title: 'Show category filter',
            type: Boolean,
            default: true
        },
        coloured: {
            title: 'Use primary color, not workout color',
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        workoutTypes: null,
        categoryFilter: null
    }),
    computed: {
        styleClass() {
            let styleClasses = ['default', 'card', 'soft'];
            return this.listStyle ? 'z-style-' + styleClasses[this.listStyle] : 'z-style-' + styleClasses[0];
        },
        workoutCategories() {
            return this.$store.state.settings?.workoutcategories?.filter(c => c.show && c.active && (this.categories.length == 0 || this.categories.indexOf(c.id) > -1)) || [];
        },
        filteredWorkoutTypes() {
            return this.workoutTypes ? this.workoutTypes.filter(x =>
                (this.categories.length == 0 || this.categories.indexOf(x.category_id)>-1) &&
                (this.categoryFilter === null || x.category_id == this.categoryFilter)
            ) : [];
        }
    },
    methods: {
        getShade(color) {
            return 'background: linear-gradient(180deg, ' + this.hex2rgba(color, 0) +' 0%, ' + this.hex2rgba(color, 1)+' 100%);';
        },
        loadWorkoutTypes() {
            this.$api.get('/api/public/workout/type/get').then(x => {
                this.workoutTypes = x.sort((a,b) => a.name.localeCompare(b.name));
            });
        },
        toggleFilter(categoryId) {
            this.categoryFilter = categoryId == this.categoryFilter ? null : categoryId;
        },
        getLink(id) {
            let linkSuffix;
            if (!this.linkParam || this.linkParam == 'id') {
                linkSuffix = '/' + id;
            } else {
                linkSuffix = '?' + this.linkParam + '=' + id;
            }
            return this.link + linkSuffix;
        },
        showType(id) {
            this.$root.followLink(this.getLink(id));
        },
        getTextColor(color) {
            color = (color.charAt(0) === '#') ? color.substring(1, 7) : color;
            var r = parseInt(color.substring(0, 2), 16); // hexToR
            var g = parseInt(color.substring(2, 4), 16); // hexToG
            var b = parseInt(color.substring(4, 6), 16); // hexToB
            return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
                'text-black' : 'text-white';
        },
        hex2rgba(hex, alpha = 1) {
            if([3,4].indexOf(hex.length)>-1) {
                let newHex = '';
                hex.replace('#', '').split('').forEach(x => newHex+= x + '' + x);
                hex = newHex;
            }
            const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
            return `rgba(${r},${g},${b},${alpha})`;
        },
        stripHtml(html) {
            return html?.replace(/<(?!br|p|a)[^>]+>/gi , "");
        }
    },
    mounted() {
        this.loadWorkoutTypes();
    }
}
</script>
